import { gql } from '@apollo/client';

export const subscribeCleaningReportAdded = gql`
  subscription SubscribeCleaningReportAdded($userId: ID!) {
    subscribeCleaningReportAdded(userId: $userId) {
      message
      machine {
        materialNumber
        alias
      }
    }
  }
`;

export const subscribeNotificationAdded = gql`
  subscription SubscribeNotificationAdded($userId: ID!) {
    subscribeNotificationAdded(userId: $userId) {
      message
      type
      severity
      machine {
        materialNumber
        alias
      }
    }
  }
`;
